import script from "./Address.vue?vue&type=script&setup=true&lang=js"
export * from "./Address.vue?vue&type=script&setup=true&lang=js"

import "./Address.vue?vue&type=style&index=0&id=774fe8be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774fe8be"]])

export default __exports__